import React from 'react';
import Link from 'gatsby-link';

export default function PCKitchen() {
  return (
    <div className="p-hero -content -kitchen">
      <div className="p-hero__body -content">
        <div className="p-content__panel">
          <div className="p-content__panel--info">
            <div className="p-content__panel--title">1F<br />KITCHEN</div>
            <div className="p-content__panel--time-title">ご利用時間</div>
            <div className="p-content__panel--time">9:30-21:30</div>
          </div>
          <div className="p-content__panel--body">
            <p>
              コトイロの顔でもある大きなキッチンは４口コンロを備えており、ダイニングテーブルはイス座りでも床座りでも、自由なレイアウトが可能です。<br />
              <br />
              仲間や家族で。お子さんも交えて。お家ではできない手のかかる料理も、ここでならみんなで楽しめます。<br />
              <br />
              キッチングッズも最低限揃っています。<br />
              詳しい使い方は詳細をご覧ください。
            </p>
            <Link to="/kitchen" className="c-button -icon">詳しい使い方へ</Link>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/index/PCKitchen.js